<script>
	import CardOperations from './ops/CardOperations.svelte';
	import CardFooter from './CardFooter.svelte';
	import CardHeader from './CardHeader.svelte';
	import CardWrapper from './CardWrapper.svelte';
	import "./shared.css";

	export let card;
	export let operations;
	export let handleClick;
	export let c;

</script>

<CardWrapper id={card.id} {handleClick} {c}>
	{#if operations}
		<CardHeader {...card} />
		<div class="gap" style="" />
		<div class="bottom-container">
			<CardOperations {operations} />
			<CardFooter {...card} />
		</div>
	{/if}
</CardWrapper>

<style lang="scss">


	.gap {
		flex-grow: 1;
	}
	.bottom-container {
		padding-top: calc(var(--height) / 100.25); //4px;
		flex-direction: column;
		background: linear-gradient(
			135deg,
			rgba(17, 78, 138, 1) 0%,
			rgba(4, 41, 77, 1) 40%,
			rgba(99, 139, 157, 1) 100%
		);
		z-index: -1;
	}
</style>
